var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteGridAnim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      height: "100%",
      width: "100%",
      background: "none",
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s"
    },
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -13.8889s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10h21.8v21.8H10z",
    fill: "#d65a62",
    style: {
      fill: "rgb(231, 231, 231)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -15.2778s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1 10h21.8v21.8H39.1z",
    fill: "#f0af6b",
    style: {
      fill: "rgb(248, 248, 248)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -16.6667s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2 10H90v21.8H68.2z",
    fill: "#f47e5f",
    style: {
      fill: "rgb(240, 240, 240)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -18.0556s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 39.1h21.8v21.8H10z",
    fill: "#f0af6b",
    style: {
      fill: "rgb(248, 248, 248)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -19.4444s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 39.1h21.8v21.8H39z",
    fill: "#f47e5f",
    style: {
      fill: "rgb(240, 240, 240)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -20.8333s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2 39.1H90v21.8H68.2z",
    fill: "#e15c64",
    style: {
      fill: "rgb(235, 235, 235)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -22.2222s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 68.2h21.8V90H10z",
    fill: "#f47e5f",
    style: {
      fill: "rgb(240, 240, 240)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -23.6111s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1 68.2h21.8V90H39.1z",
    fill: "#e15c64",
    style: {
      fill: "rgb(235, 235, 235)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "scale(0.85)",
      animation: "25s linear -25s infinite normal forwards running pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2 68.2H90V90H68.2z",
    fill: "#f7b26a",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f",
    "data-anikit": ""
  }, "\n    @keyframes pulse-55e7209b-9a0b-4cd0-b2c8-248d07bb439f {\n      0% {\n        animation-timing-function: cubic-bezier(0.3333, 0.3333, 0.3124, 0.6668);\n        transform: scale(0.85);\n      }\n\n      0.5% {\n        animation-timing-function: cubic-bezier(0.0233, -0.3865, 0.6667, 0.6667);\n        transform: scale(1.141);\n      }\n\n      1.5% {\n        animation-timing-function: cubic-bezier(0.2893, 0.354, 0.6158, 0.6958);\n        transform: scale(1.124);\n      }\n\n      11% {\n        animation-timing-function: cubic-bezier(0.2861, 0.4196, 0.6215, 0.7476);\n        transform: scale(0.992);\n      }\n\n      25% {\n        animation-timing-function: cubic-bezier(0.0793, 0.2627, 0.9972, 1.5511);\n        transform: scale(0.887);\n      }\n\n      49.5% {\n        animation-timing-function: cubic-bezier(0.6664, 0.3332, 0.6667, 0.6667);\n        transform: scale(0.85);\n      }\n\n      50% {\n        animation-timing-function: cubic-bezier(0, 0.3522, 1, 0.6686);\n        transform: scale(1.1500000000000001);\n      }\n\n      51% {\n        animation-timing-function: cubic-bezier(0.2668, 0.4036, 0.554, 0.7657);\n        transform: scale(1.1320000000000001);\n      }\n\n      73.5% {\n        animation-timing-function: cubic-bezier(0.2997, 1.0028, 0.6671, 1);\n        transform: scale(0.894);\n      }\n\n      100% {\n        transform: scale(0.85);\n      }\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGridAnim);
export default __webpack_public_path__ + "static/media/white-grid-anim.9327874c5506f2b7c30a580ea261866b.svg";
export { ForwardRef as ReactComponent };